var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVtLogo = function SvgVtLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 201,
    height: 50,
    fill: "none",
    viewBox: "0 0 201 50"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#16F9D3",
    d: "M37.224 39.77h-8.478V6h17.756v14.22h-9.278v19.552z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillOpacity: 0.7,
    d: "M37.224 39.77h-8.478V6h17.756v14.22h-9.278v19.552z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F8F9",
    d: "M25.755 39.77h-8.428V20.22H8V6h17.755zM67.868 30.616h3.53V17.62h4.973v-2.494H62.895v2.494h4.973zM94.89 30.616h10.168V28.09h-6.671V15.127h-3.495v15.489zM108.374 30.616h10.807v-2.493h-7.309v-4.122h5.707V21.51h-5.707v-3.89h6.942v-2.492h-10.44zM79.848 30.616h10.806v-2.493h-7.309v-4.122h5.708V21.51h-5.708v-3.89h6.942v-2.492H79.85zM131.305 30.663h1.399l4.919-10.082v10.017h3.195v-15.49h-3.681l-4.99 10.443-4.868-10.443h-3.71v15.49h3.062v-9.874zM155.843 30.63h3.757l-6.061-15.489h-3.21l-6.06 15.489h3.759l1.302-3.51h5.279zm-2.091-6.034h-3.778l2.01-5.465zM171.644 30.63h3.546l-3.761-6.373.17-.033c1.758-.48 3.151-1.875 3.151-4.37 0-2.836-1.382-4.714-5.197-4.714h-6.413v15.488h3.495v-5.964h1.522l3.488 5.964zm-2.753-8.31h-2.257v-4.785h2.257c1.634 0 2.505.971 2.505 2.404 0 1.168-.553 2.381-2.505 2.381M188.209 30.63h3.889l-6.107-7.838 5.759-7.651h-3.935l-5.072 6.966V15.14h-3.495V30.63h3.495v-7.026l5.468 7.026z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(9.84713 -10.8941 5.72777 32.0798 34.873 21.33)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A693"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#16F9D3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: 200.37,
    height: 51,
    x: 0,
    y: -0.432,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_205_2926"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_205_2926",
    result: "effect2_dropShadow_205_2926"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_205_2926",
    result: "shape"
  })))));
};
export default SvgVtLogo;